import { Component, OnInit } from '@angular/core';
import {catchError, finalize} from 'rxjs/operators';
import {RequestsService} from '../../../requests/services/requests.service';
import {forkJoin, of} from 'rxjs';
import { EnvService } from '../../../env.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html'
})
export class VersionComponent implements OnInit {

  constructor(private requestService: RequestsService, private envService: EnvService) { }

  readonly versions = {
    fn: '',
    api: '',
    ui: ''
  };

  public loading = false;

  ngOnInit(): void {
    this.updateVersions();
  }

  updateVersions(): void {
    this.loading = true;
    this.versions.ui = environment.appVersion + '-' + environment.commitId;
    forkJoin([
      this.requestService.getAPIversion().pipe(catchError(() => of(''))),
      this.requestService.getFnVersion().pipe(catchError(() => of(''))),
      // this.requestService.getUIversion().pipe(catchError(() => of(''))),
    ])
      .pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(([apiVersion, fnVersion]) => {
        this.versions.api = apiVersion;
        this.versions.fn = fnVersion;
        // this.versions.ui = uiVersion;
      });
  }

}
